"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dividePeriodByMinutes = void 0;
const date_fns_1 = require("date-fns");
const period_1 = require("./period");
/**
 * PeriodをX分毎に分割する
 * @param period
 * @param minutes
 * @example
 * dividePeriodByMinutes(new Period(new Date('2021-01-01 10:00'), new Date('2021-01-01 11:00')), 30)
 * => [
 *  new Period(new Date('2021-01-01 10:00'), new Date('2021-01-01 10:30')),
 *  new Period(new Date('2021-01-01 10:30'), new Date('2021-01-01 11:00')),
 * ]
 */
const dividePeriodByMinutes = (period, interval) => {
    const result = [];
    let start = period.start;
    while ((0, date_fns_1.addMinutes)(start, interval) <= period.end) {
        const newPeriod = new period_1.Period(start, (0, date_fns_1.addMinutes)(start, interval));
        result.push(newPeriod);
        start = (0, date_fns_1.addMinutes)(start, interval);
    }
    return result;
};
exports.dividePeriodByMinutes = dividePeriodByMinutes;
//# sourceMappingURL=dividePeriodByMinutes.js.map